import { canUseDom } from './CanUseDom'

export let supportsPassive = false

if (canUseDom) {
  try {
    const opts = {}
    Object.defineProperty(opts, 'passive', {
      get() {
        supportsPassive = true
        return true
      },
    })
    window.addEventListener('test-passive', null as any, opts)
  } catch (e) {
    console.log(e)
  }
}
